import { on } from "@ngrx/store";
import { CatalogState } from "../catalog.state";
import { CatalogsActions } from "./catalogs.actions";
import { CatalogManagementActions } from "../../admin/contract-admin/catalog-management/catalog-management.actions";
import { UserActions } from "../../../user/user.actions";
import { PagesStore } from "../../pages.state";

// **************************************************************************
// HELPER: Update catalog state within PagesStore
// **************************************************************************

function withCatalog(state: PagesStore, updater: (catalog: CatalogState) => CatalogState): PagesStore {
    return { ...state, catalog: updater(state.catalog) };
}

// **************************************************************************
// CATALOGS LIST REDUCER (flattened structure)
// **************************************************************************

const load = on(CatalogsActions.load, (state: PagesStore) => withCatalog(state, catalogState => ({
    ...catalogState,
    loadingList: true,
})));

const loadSuccess = on(CatalogsActions.loadSuccess, (state: PagesStore, { catalogs }) => withCatalog(state, catalogState => ({
    ...catalogState,
    catalogs,
    loaded: true,
    loadingList: false,
    error: null,
})));

const loadFailure = on(CatalogsActions.loadFailure, (state: PagesStore, { error }) => withCatalog(state, catalogState => ({
    ...catalogState,
    loadingList: false,
    error,
})));

const invalidate = on(
    CatalogsActions.invalidate,
    UserActions.changeCompanySuccess,
    (state: PagesStore) => withCatalog(state, catalogState => ({
        ...catalogState,
        loaded: false,
    })),
);

// **************************************************************************
// HANDLE CONTRACT-ADMIN CRUD ACTIONS
// **************************************************************************

const createCatalogSuccess = on(CatalogManagementActions.createCatalogSuccess, (state: PagesStore, { catalog }) => withCatalog(state, catalogState => ({
    ...catalogState,
    catalogs: [...catalogState.catalogs, catalog],
})));

const deleteCatalogSuccess = on(CatalogManagementActions.deleteCatalogSuccess, (state: PagesStore, { id }) => withCatalog(state, catalogState => ({
    ...catalogState,
    catalogs: catalogState.catalogs.filter(c => c.id !== id),
})));

const uploadCatalogImageSuccess = on(CatalogManagementActions.uploadCatalogImageSuccess, (state: PagesStore, { catalog }) => withCatalog(state, catalogState => ({
    ...catalogState,
    catalogs: catalogState.catalogs.map(c => c.id === catalog.id ? catalog : c),
})));

export const catalogsReducer = [
    load,
    loadSuccess,
    loadFailure,
    invalidate,
    createCatalogSuccess,
    deleteCatalogSuccess,
    uploadCatalogImageSuccess,
];
